import { useEffect } from "react";

export const useMobileSearchFocus = ({
  mobileOverlayOpen,
  mobileSearchInputRef,
}) => {
  useEffect(() => {
    if (!mobileOverlayOpen) return;
    const timeout = setTimeout(() => mobileSearchInputRef.current?.focus(), 30);
    return () => clearTimeout(timeout);
  }, [mobileOverlayOpen, mobileSearchInputRef]);
};
